import React from "react";

const EventSurveyIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.44034 0.349623C4.27105 0.381823 4.11858 0.472818 4.00986 0.606535C3.90115 0.740252 3.84319 0.908087 3.84623 1.08039V1.81116H1.21984C0.635229 1.81116 0.192383 2.25401 0.192383 2.83862V18.2535C0.192383 18.9112 0.635229 19.3496 1.21984 19.3496H13.7116C14.2962 19.3496 14.7391 18.9068 14.7391 18.3222V2.83862C14.8122 2.25401 14.3649 1.81116 13.7803 1.81116H11.1539V1.08039C11.1539 0.886581 11.0769 0.700707 10.9399 0.563661C10.8028 0.426615 10.617 0.349623 10.4232 0.349623H4.577C4.55411 0.348547 4.53119 0.348547 4.50831 0.349623C4.48542 0.348547 4.46323 0.348547 4.44034 0.349623ZM5.30777 1.81116H9.69238V3.2727H5.30777V1.81116ZM1.65392 3.2727H3.84623V4.00347C3.84623 4.19728 3.92322 4.38316 4.06027 4.5202C4.19731 4.65725 4.38319 4.73424 4.577 4.73424H10.4232C10.617 4.73424 10.8028 4.65725 10.9399 4.5202C11.0769 4.38316 11.1539 4.19728 11.1539 4.00347V3.2727H13.3462V17.8881H1.65392V3.2727ZM3.11546 6.92655V9.84962H6.03854V6.92655H3.11546ZM3.84623 7.65732H5.30777V9.11885H3.84623V7.65732ZM7.50007 7.65732V9.11885H11.8847V7.65732H7.50007ZM3.11546 11.3112V14.2342H6.03854V11.3112H3.11546ZM7.50007 12.0419V13.5035H11.8847V12.0419H7.50007Z"
        fill={fill}
      />
    </svg>
  );
};

EventSurveyIcon.defaultProps = {
  width: "15",
  height: "19",
  fill: "#000",
};

export default EventSurveyIcon;
